import { createSlice } from '@reduxjs/toolkit';
import { ManagedBootstrapState } from 'interfaces/managed-blocking.interface';
import { fetchManagedBootstrap } from './extra';

export const initialManagedBlockingState: ManagedBootstrapState = {
  data: null,
  isLoading: false,
  hasError: false
};
const slice = createSlice({
  name: 'managedBlocking',
  initialState: initialManagedBlockingState,
  reducers: { clearManagedBlocking: () => initialManagedBlockingState },
  extraReducers: (builder) => {
    builder.addCase(fetchManagedBootstrap.pending, (state, action) => {
      state.isLoading = true;
      state.hasError = false;
      state.data = null;
      state.requestId = action.meta.requestId;
    });
    builder.addCase(fetchManagedBootstrap.fulfilled, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.data = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchManagedBootstrap.rejected, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.hasError = true;
      state.isLoading = false;
    });
  }
});
export const { clearManagedBlocking } = slice.actions;
export default slice.reducer;
